import { gql } from "@apollo/client"

const NOTIFICATION_FRAGMENT = gql`
  fragment NotificationFields on Notification {
    id
    title
    description
    active
    created_at
    no_of_recipients
    
    sesEmailBatch {
      id
      no_of_emails
      no_of_queued
      no_of_delivered
      no_of_failed
      created_at
    }

    status {
      id
      name
      code
    }
    
    recipientType {
      id
      name
      code
    }
    
    type {
      id
      name
      code
      is_app
      is_email
    }
  }
`

export default NOTIFICATION_FRAGMENT